module.exports = __webpack_public_path__ + "static/media/Avvale-logo-hor-white.a7b4a25a.png";